// Angular
import { BehaviorSubject, Observable, takeUntil } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Services
import { AppCleanup, CompanyUserViewModel } from '../../../shared/models';
import { CoreService } from '../../../shared/services/core.service';

// Models
import { CompanyListModel, CompanyRegisterModel } from '../models/company-view-model.model';
import { CompanyDetailViewModel } from '../models/company-detail-view.model';
import { CompanyUserToAddDto } from '../models/company-user-to-add-dto';
import { CompanyUser } from '../models/company-user.model';
import { CompanyToEditDto } from '../models/company-to-edit-dto.model';
import { CompanyUserToEditDto } from '../models/company-user-to-edit-dto';
import { CompanyEditModel } from '../models/CompanyEditModel';

// Libraries

import { orderBy } from 'lodash-es';

@Injectable({
	providedIn: 'root',
})
export class CompanyService extends AppCleanup {
	// @Select(AuthState.isLoggedIn) isLoggedIn$: Observable<boolean>;
	companiesList: CompanyListModel[] = [];
	protected companiesListReadyVar: BehaviorSubject<CompanyListModel[]> = new BehaviorSubject<CompanyListModel[]>(null);
	companiesListReady$ = this.companiesListReadyVar.asObservable();
	readonly companyUrl: string = `${this.apiUrl}api/company`;

	constructor(
		private http: HttpClient,
		private coreService: CoreService
	) {
		super();
	}

	refreshCompanies() {
		// this.isLoggedIn$.pipe(takeUntil(this.destroy)).subscribe(isLoggedIn => { // Non authenticated users don't have a set assigned of companies
		// 	if (isLoggedIn) {
		// 		this.initCompaniesList();
		// 	}
		// });

		this.initCompaniesList();
	}

	getCompaniesRegister() {
		const url: string = `${this.companyUrl}/register`;
		return this.http.get<CompanyRegisterModel[]>(url);
	}

	getCompanies() {
		return this.http.get<CompanyListModel[]>(this.companyUrl + '/list');
	}

	getCompany(id: number): Observable<CompanyEditModel> {
		const url: string = `${this.companyUrl}/edit/${id}`;
		return this.http.get<CompanyEditModel>(url);
	}

	createCompany(companyToEditDto: CompanyToEditDto) {
		return this.http.post<CompanyDetailViewModel>(this.companyUrl, companyToEditDto);
	}

	addUsersToCompany(companyUserToAddDto: CompanyUserToAddDto) {
		const url: string = `${this.companyUrl}/companyuser`;
		return this.http.post<CompanyUserViewModel[]>(url, companyUserToAddDto);
	}

	editUserToCompany(companyUserToAddDto: CompanyUserToEditDto) {
		const url: string = `${this.companyUrl}/companyuser`;
		return this.http.put<CompanyUser>(url, companyUserToAddDto);
	}

	removeUserFromCompany(companyUserId: number) {
		const url: string = `${this.companyUrl}/companyuser/${companyUserId}`;
		return this.http.delete<CompanyUser>(url);
	}

	isUserAdminForCompany(companyId: number): Observable<boolean> {
		const url: string = `${this.companyUrl}/admin/${companyId}`;
		return this.http.get<boolean>(url);
	}

	getCompanyUser(companyId: number, userId: number) {
		const url: string = `${this.companyUrl}/companyuser?companyId=${companyId}&userId=${userId}`;
		return this.http.get<CompanyUserViewModel>(url);
	}

	initCompaniesList() {
		this.http
			.get<CompanyListModel[]>(this.companyUrl + '/list')
			.pipe(takeUntil(this.destroy))
			.subscribe((companiesList: CompanyListModel[]) => {
				if (companiesList) {
					this.companiesList = orderBy(companiesList, ['isActive', 'name'], ['desc', 'asc']);
					this.companiesListReadyVar.next(this.companiesList);
				}
			});
	}

	updateCompany(companyToEditDto: CompanyToEditDto) {
		return this.http.put<CompanyDetailViewModel>(`${this.companyUrl}`, companyToEditDto);
	}
}
